import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = typeof obj?.[key] === 'object' ? toCamelCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

const toSnakeCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, (letter) => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = typeof obj?.[key] === 'object' ? toSnakeCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

export const userService = {
  // Get current user profile
  async getCurrentProfile() {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('user_profiles')?.select('*, companies(*)')?.eq('id', user?.id)?.single();

      if (error) throw error;
      return toCamelCase(data);
    } catch (error) {
      console.error('Error fetching profile:', error?.message);
      throw error;
    }
  },

  // Update user profile
  async updateProfile(profileData) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const snakeData = toSnakeCase(profileData);

      const { data, error } = await supabase?.from('user_profiles')?.update(snakeData)?.eq('id', user?.id)?.select()?.single();

      if (error) throw error;
      return toCamelCase(data);
    } catch (error) {
      console.error('Error updating profile:', error?.message);
      throw error;
    }
  },

  // Update company information
  async updateCompany(companyId, companyData) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const snakeData = toSnakeCase(companyData);

      const { data, error } = await supabase?.from('companies')?.update(snakeData)?.eq('id', companyId)?.select()?.single();

      if (error) throw error;
      return toCamelCase(data);
    } catch (error) {
      console.error('Error updating company:', error?.message);
      throw error;
    }
  },

  // Get company members
  async getCompanyMembers(companyId) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('company_id', companyId)?.order('created_at', { ascending: false });

      if (error) throw error;
      return toCamelCase(data);
    } catch (error) {
      console.error('Error fetching company members:', error?.message);
      throw error;
    }
  },

  // Update password
  async updatePassword(newPassword) {
    try {
      const { error } = await supabase?.auth?.updateUser({
        password: newPassword
      });

      if (error) throw error;
    } catch (error) {
      console.error('Error updating password:', error?.message);
      throw error;
    }
  }
};